// Badge difficulty tiers — Armenian mountains in ascending significance.
// Legacy values (easy / medium / hard) are auto-mapped so existing data keeps rendering.

export const DIFFICULTY_TIERS = [
  { value: "aragadz", label: "Aragadz", labelHy: "Արագած", legacy: "easy" },
  { value: "sipan",   label: "Sipan",   labelHy: "Սիփան",   legacy: "medium" },
  { value: "ararat",  label: "Ararat",  labelHy: "Արարատ",  legacy: "hard" },
];

const LEGACY_MAP = { easy: "aragadz", medium: "sipan", hard: "ararat" };

export function normalizeDifficulty(d) {
  if (!d) return "sipan";
  const key = String(d).toLowerCase();
  if (LEGACY_MAP[key]) return LEGACY_MAP[key];
  return DIFFICULTY_TIERS.find(t => t.value === key) ? key : "sipan";
}

export function difficultyLabel(d, lang = "en") {
  const norm = normalizeDifficulty(d);
  const tier = DIFFICULTY_TIERS.find(t => t.value === norm);
  if (!tier) return d || "";
  return lang === "hy" ? tier.labelHy : tier.label;
}
